var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlansIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.087,
    height: 20.247,
    viewBox: "0 0 22.087 20.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder",
    d: "M17.486,2.841H11.478a.938.938,0,0,1-.411-.092l-2.9-1.458A2.774,2.774,0,0,0,6.928,1H4.6A4.607,4.607,0,0,0,0,5.6V16.645a4.607,4.607,0,0,0,4.6,4.6H17.486a4.607,4.607,0,0,0,4.6-4.6v-9.2a4.607,4.607,0,0,0-4.6-4.6ZM4.6,2.841H6.928a.938.938,0,0,1,.411.092l2.9,1.453a2.774,2.774,0,0,0,1.234.3h6.008a2.761,2.761,0,0,1,2.558,1.732l-18.2.1V5.6A2.761,2.761,0,0,1,4.6,2.841ZM17.486,19.406H4.6a2.761,2.761,0,0,1-2.761-2.761V8.357l18.406-.1v8.392A2.761,2.761,0,0,1,17.486,19.406Z",
    transform: "translate(0 -1)",
    fill: "#ff643a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIcon3);
export default __webpack_public_path__ + "static/media/plans-icon3.10369bfe5f6d867c43cac9417f7b1869.svg";
export { ForwardRef as ReactComponent };